<template>
    <div class="w-100" v-if="values">
        <div class="w-100 d-flex flex-column align-items-start" v-if="isEdit">
            <validation-observer
                :initialValues="{
                    beanstream_merchant_id: values.gateway.beanstream_merchant_id,
                    beanstream_pass_code: values.gateway.beanstream_pass_code,
                    beanstream_username: values.gateway.beanstream_username,
                    beanstream_password: values.gateway.beanstream_password,
                }"
                ref="authnet_form"
                v-slot="{ meta, errors, setFieldValue }"
            >
                <validation-provider name="beanstream_merchant_id" rules="required">
                    <form-input
                        label="Merchant ID:"
                        :error="errors.beanstream_merchant_id"
                        v-model="values.gateway.beanstream_merchant_id"
                        @input="(val) => setFieldValue('beanstream_merchant_id', val)"
                    />
                </validation-provider>
                <validation-provider name="beanstream_pass_code" rules="required">
                    <form-input
                        label="Pass Code:"
                        type="password"
                        :error="errors['beanstream_pass_code']"
                        v-model="values.gateway.beanstream_pass_code"
                        @input="(val) => setFieldValue('beanstream_pass_code', val)"
                    />
                </validation-provider>
                <validation-provider name="beanstream_username" rules="required">
                    <form-input
                        label="Username:"
                        :error="errors['beanstream_username']"
                        v-model="values.gateway.beanstream_username"
                        @input="(val) => setFieldValue('beanstream_username', val)"
                    />
                </validation-provider>
                <validation-provider rules="required" name="beanstream_password">
                    <form-input
                        label="Password:"
                        type="password"
                        :error="errors['beanstream_password']"
                        v-model="values.gateway.beanstream_password"
                        @input="(val) => setFieldValue('beanstream_password', val)"
                    />
                </validation-provider>
                <form-checkbox v-model="values.gateway.beanstream_pre_auth_enabled">
                    Enable preauthorization (also called authorization hold) capability.
                </form-checkbox>
                <a
                    class="link mb-3 d-block"
                    href="https://support.lodgix.com/en/articles/3323756-switching-to-stripe-canada-from-bambora-beanstream"
                    target="_blank"
                >
                    Instructions on how to obtain Bambora credentials</a
                >
                <div class="submit-buttons-wrapper">
                    <b-button :disabled="!meta.valid" class="mr-2" variant="primary" @click="onSave">Save</b-button>
                    <b-button variant="default" @click="onCancel">Cancel</b-button>
                </div>
            </validation-observer>
        </div>
        <div v-else class="w-100">
            <div class="d-flex flex-column">
                <div class="d-flex flex-column align-items-start mb-2">
                    <span>Merchant ID:</span>
                    <h3 class="text-primary cursor-pointer" @click="onEdit">
                        {{ values.gateway.beanstream_merchant_id }}
                    </h3>
                </div>
                <div class="d-flex flex-column align-items-start mb-2">
                    <span>Pass Code:</span>
                    <h3 class="text-primary cursor-pointer" @click="onEdit">**********</h3>
                </div>
                <div class="d-flex flex-column align-items-start mb-2">
                    <span>Username: </span>
                    <h3 class="text-primary cursor-pointer" @click="onEdit">
                        {{ values.gateway.beanstream_username }}
                    </h3>
                </div>
                <div class="d-flex flex-column align-items-start mb-2">
                    <span>Password:</span>
                    <h3 class="text-primary cursor-pointer" @click="onEdit">**********</h3>
                </div>
                <div class="d-flex align-items-center mb-3">
                    <h3 @click="onEdit" class="text-primary mr-3">
                        {{ values.gateway.beanstream_pre_auth_enabled ? 'On' : 'Off' }}
                    </h3>
                    <span>Enable preauthorization (also called authorization hold) capability.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import { paymentComponentMixin } from './mixin.js';

    export default {
        name: 'BeanstreamEdit',
        components: { FormInput, FormCheckbox },
        mixins: [paymentComponentMixin],
    };
</script>

<style></style>
